// extracted by mini-css-extract-plugin
export default {"Container":"SingleExtraction_Container__TBNZW","Content":"SingleExtraction_Content__GRoCm","Loading":"SingleExtraction_Loading__XP76j","Head":"SingleExtraction_Head__b4vDm"};